<template>
  <Loader v-if="loading"></Loader>
  <div class="center-content">
    <!-- Prima sezione - Ricerca per data -->
    <Card class="history-card w-full">
      <template v-slot:content>
        <div v-if="showDateRangeAlert && isSearchPerformed && !isSearchErrorePerformed" class="alert alert-danger">
          Devi selezionare un range di date
        </div>
        <div class="filters">
          <div class="date-picker-container">
            <label for="dateRange">Seleziona Intervallo Di Date</label>
            <div class="date-range-box-wrapper">
              <div class="date-range-box">
                <Calendar v-model="dateRange" id="dateRange" selectionMode="range" dateFormat="yy-mm-dd" placeholder="Seleziona data di inizio e fine" />
              </div>
              <button @click="performSearch" class="search-button">
                <i class="pi pi-search"></i>
              </button>
            </div>
          </div>
        </div>
        <TabView v-if="isSearchPerformed && isDateRangeValid">
          <TabPanel>
            <template #header>
              Sending
              <span class="tab-count">({{ countByState.sending }})</span>
            </template>
            <div class="tab-content">
              <input v-model="searchTerm" type="text" placeholder="Inserisci numero fattura" class="tab-search-input" />
              <div class="table-container">
                <DataTable :value="paginatedFilteredLogMessagesByState(1)" tableStyle="min-width: 50rem" scrollable="true" class="file-table">
                  <Column header="Numero Fattura" style="width: 150px">
                    <template #body="{ data }">
                      <a @click="openInvoice(data.numero)" href="javascript:void(0)">{{ data.numero }}</a>
                    </template>
                  </Column>
                  <Column field="hubId" header="hubId" style="width: 100px"></Column>
                  <Column field="timestamp" header="Data" style="width: 200px">
                    <template #body="{ data }">
                      {{ moment(data.timeCreazione && moment(data.timeCreazione, "YYYY-MM-DD HH:mm:ss").isAfter(moment(data.timestamp, "YYYY-MM-DD HH:mm:ss")) ? data.timeCreazione : data.timestamp, "YYYY-MM-DD HH:mm:ss").format("YYYY-MM-DD HH:mm:ss") }}
                    </template>
                  </Column>
                </DataTable>
              </div>
            </div>
            <div v-if="isSearchPerformed && isDateRangeValid && filteredLogMessagesByState(1).length" class="pagination">
              <button @click="prevPageSending" :disabled="currentPageSending === 1">Previous</button>
              <span>Page {{ currentPageSending }} of {{ totalPagesByState(1) }}</span>
              <button @click="nextPageSending" :disabled="currentPageSending === totalPagesByState(1)">Next</button>
            </div>
          </TabPanel>
          <TabPanel>
            <template #header>
              Sent <span class="tab-count">({{ countByState.sent }})</span>
            </template>
            <div class="tab-content">
              <input v-model="searchTerm" type="text" placeholder="Inserisci numero fattura" class="tab-search-input" />
              <div class="table-container">
                <DataTable :value="paginatedFilteredLogMessagesByState(2)" tableStyle="min-width: 50rem" scrollable="true" class="file-table">
                  <!-- Colonne per Sent identiche a Sending -->
                  <Column header="Numero Fattura" style="width: 150px">
                    <template #body="{ data }">
                      <a @click="openInvoice(data.numero)" href="javascript:void(0)">{{ data.numero }}</a>
                    </template>
                  </Column>
                  <Column field="hubId" header="hubId" style="width: 100px"></Column>
                  <Column field="timestamp" header="Data" style="width: 200px">
                    <template #body="{ data }">
                      {{ moment(data.timestamp, "YYYY-MM-DD HH:mm:ss").format("YYYY-MM-DD HH:mm:ss") }}
                    </template>
                  </Column>
                </DataTable>
              </div>
            </div>
            <div v-if="isSearchPerformed && isDateRangeValid && filteredLogMessagesByState(2).length" class="pagination">
              <button @click="prevPageSent" :disabled="currentPageSent === 1">Previous</button>
              <span>Page {{ currentPageSent }} of {{ totalPagesByState(2) }}</span>
              <button @click="nextPageSent" :disabled="currentPageSent === totalPagesByState(2)">Next</button>
            </div>
          </TabPanel>
          <TabPanel>
            <template #header>
              Inviata <span class="tab-count">({{ countByState.inviata }})</span>
            </template>
            <div class="tab-content">
              <input v-model="searchTerm" type="text" placeholder="Inserisci numero fattura" class="tab-search-input" />
              <div class="table-container">
                <DataTable :value="paginatedFilteredLogMessagesByState(3)" tableStyle="min-width: 50rem" scrollable="true" class="file-table">
                  <!-- Colonne per Inviata identiche alle precedenti -->
                  <Column header="Numero Fattura" style="width: 150px">
                    <template #body="{ data }">
                      <a @click="openInvoice(data.numero)" href="javascript:void(0)">{{ data.numero }}</a>
                    </template>
                  </Column>
                  <Column field="hubId" header="hubId" style="width: 100px"></Column>
                  <Column field="timestamp" header="Data" style="width: 200px">
                    <template #body="{ data }">
                      {{ moment(data.timestamp, "YYYY-MM-DD HH:mm:ss").format("YYYY-MM-DD HH:mm:ss") }}
                    </template>
                  </Column>
                </DataTable>
              </div>
            </div>
            <div v-if="isSearchPerformed && isDateRangeValid && filteredLogMessagesByState(3).length" class="pagination">
              <button @click="prevPageInviata" :disabled="currentPageInviata === 1">Previous</button>
              <span>Page {{ currentPageInviata }} of {{ totalPagesByState(3) }}</span>
              <button @click="nextPageInviata" :disabled="currentPageInviata === totalPagesByState(3)">Next</button>
            </div>
          </TabPanel>
        </TabView>
      </template>
    </Card>
    <Card class="error-card w-full">
      <template v-slot:content>
        <div v-if="showDateRangeAlert && isSearchPerformedErrore && !isSearchPerformed" class="alert alert-danger">
          Devi selezionare un range di date
        </div>
        <h4 class="titoloH4">Cerca Solo Le Fatture In Errore</h4>

        <div class="filters">
          <div class="search-controls">
            <Button 
              label="Cerca Fatture in Errore" 
              @click="performSearchErrore" 
              class="search-button-primary"
            />
            <Button 
              v-if="!loadingFattureDaRinviare" 
              :label="`Clicca per rinviare (${fattureDaRinviareCount})`" 
              @click="rinviaTutteFattureErrore" 
              class="rinvia-button"
            />
          </div>
        </div>

        <div v-if="isSearchPerformedErrore && isDateRangeErrorValid">
          <div class="table-container">
            <input 
              v-model="searchTermErrore" 
              type="text" 
              placeholder="Inserisci numero fattura" 
              class="tab-search-input mb-4" 
            />
            <span class="tab-count">{{ errorLogCount }} totali, di cui {{ countWithButton }} da gestire</span>

            <DataTable 
              :value="filteredErrorLogMessagesSorted" 
              tableStyle="min-width: 50rem" 
              scrollable="true"
              class="file-table"
            >
              <Column header="Numero Fattura" style="width: 150px">
                <template #body="{ data }">
                  <a @click="openInvoice(data.numero)" href="javascript:void(0)">{{ data.numero }}</a>
                </template>
              </Column>
              <Column header="Stato" style="width: 350px">
                <template #body="slotProps">
                  {{ slotProps.data.statoScartate || slotProps.data.stato }}
                </template>
              </Column>
              <Column header="Motivo Errore" style="width: 350px">
                <template #body="slotProps">
                  {{ slotProps.data.motivazione || slotProps.data.message }}
                </template>
              </Column>
              <Column field="creation_time" header="Data Creazione" style="width: 350px"></Column>
              <Column header="Rimetti Da Inviare" style="width: 150px">
                <template #body="slotProps">
                  <Button 
                    v-if="slotProps.data.gestito == 0" 
                    label="Rimetti Da Inviare" 
                    @click="inviaFatturaAgyo(slotProps.data.numero)" 
                  />
                </template>
              </Column>
            </DataTable>
          </div>
        </div>

        <div v-if="isSearchPerformedErrore && isDateRangeErrorValid && filteredErrorLogMessages.length" class="pagination">
          <button @click="prevErrorPage" :disabled="currentErrorPage === 1">Previous</button>
          <span>Page {{ currentErrorPage }} of {{ totalErrorPages }}</span>
          <button @click="nextErrorPage" :disabled="currentErrorPage === totalErrorPages">Next</button>
        </div>
      </template>
    </Card>
    <Card class="count-stati-card w-full">
      <template v-slot:content>
        <h4 class="titoloH4">Count Stati Fatture Agyo</h4>
        
        <div class="filters">
          <div class="date-picker-container">
            <label for="meseCount">Seleziona Mese</label>
            <Calendar 
              v-model="selectedMonth" 
              view="month" 
              dateFormat="yy-mm"
              :showIcon="true"
              @date-select="getCountStati"
            />
          </div>
        </div>

        <div v-if="loadingStatiCount" class="loader-container">
          <Loader />
        </div>

        <div v-else-if="statiCount" class="stati-grid">
          <div class="stato-box">
            <h5>Partite Da Inbox</h5>
            <span class="count">{{ statiCount.conteggi_per_stato['1'] || 0 }}</span>
          </div>
          <div class="stato-box">
            <h5>Inviate ad agyo </h5>
            <span class="count">{{ statiCount.conteggi_per_stato['2'] || 0 }}</span>
          </div>
          <div class="stato-box" @click="showDifferences('2_3')">
            <h5>Inviate Definitivamente</h5>
            <span class="count">{{ statiCount.conteggi_per_stato['3'] || 0 }}</span>
          </div>
          <div class="stato-box" @click="showDifferences('4')">
            <h5>Errore</h5>
            <span class="count">{{ statiCount.conteggi_per_stato['4'] || 0 }}</span>
          </div>
          <div class="stato-box" @click="showDifferences('5')">
            <h5>Vuote</h5>
            <span class="count">{{ statiCount.conteggi_per_stato['5'] || 0 }}</span>
          </div>
        </div>
      </template>
    </Card>
    <div class="horizontal-sections-wrapper">
      <Card class="section-card">
        <template v-slot:content>
          <h4 class="titoloH4">Cerca Per Numero Fattura</h4>
          <div class="filters">
            <div class="date-range-box-wrapper">
              <input v-model="searchInvoiceNumber" type="text" placeholder="Inserisci Numero Fattura" id="invoiceNumber" class="tab-search-input" />
              <button @click="performInvoiceSearch" class="search-button">
                <i class="pi pi-search"></i>
              </button>
            </div>
          </div>

          <div v-if="invoiceDetails && invoiceDetails.length === 0" class="no-data-message">
            Nessuna fattura trovata.
          </div>

          <div class="table-container" v-else-if="invoiceDetails && invoiceDetails.length">
            <DataTable :value="invoiceDetails" tableStyle="min-width: 50rem" scrollable="true">
              <Column header="Numero Fattura" style="width: 150px">
                <template #body="{ data }">
                  <a @click="openInvoice(data.numero)" href="javascript:void(0)">{{ data.numero }}</a>
                </template>
              </Column>
              <Column field="hubId" header="Hub ID" style="width: 180px; word-wrap: break-word">
                <template #body="{ data }">
                  <span class="table-cell">{{ data.hubId }}</span>
                </template>
              </Column>
              <Column field="timestamp" header="Data" style="width: 180px">
                <template #body="{ data }">
                  {{ moment(data.timestamp, "YYYY-MM-DD HH:mm:ss").format("YYYY-MM-DD HH:mm:ss") }}
                </template>
              </Column>
              <Column field="esitoSDI" header="Esito SDI" style="width: 150px"></Column>
              <Column field="dataSDI" header="Data SDI" style="width: 180px">
                <template #body="{ data }">
                  {{ data.dataSDI ? moment(data.dataSDI, "YYYY-MM-DD HH:mm:ss").format("YYYY-MM-DD HH:mm:ss") : "" }}
                </template>
              </Column>
              <Column field="nomeStato" header="Stato" style="width: 100px"></Column>
              <Column field="message" header="Errore" style="width: 100px"></Column>
            </DataTable>
          </div>
        </template>
      </Card>

      <!-- Sezione 2: Fatture Vuote -->
      <Card class="section-card">
        <template v-slot:content>
          <h4 class="titoloFatture">Fatture Vuote Recuperate</h4>
          <div v-if="loadingFattureVuote">
            <Loader />
          </div>
          <div v-else class="table-container">
  <div class="search-controls">
    <input v-model="searchTermFattureVuote" type="text" placeholder="Cerca per Numero Fattura" class="tab-search-input" />
    <button @click="getFattureVuote" class="search-button">
      <i class="pi pi-search"></i>
    </button>
  </div>
            <DataTable v-if="fattureVuote.length > 0" :value="filteredFattureVuote" tableStyle="min-width: 50rem" :scrollable="true" paginator :rows="100" :lazy="true" :totalRecords="fattureVuote.length" :first="first" @page="onPage" :sortField="sortField" :sortOrder="sortOrder" @sort="onSort" class="file-table">
              <Column field="filename" header="Filename" style="width: 200px; min-width: 200px" />
              <Column field="numero" header="Numero Fattura" style="width: 150px; min-width: 150px" />
              <Column field="date" header="Data" sortable style="width: 150px">
                <template #body="{ data }">
                  {{ moment(data.date, "YYYY-MM-DD").format("YYYY-MM-DD") }}
                </template>
              </Column>
              <Column header="Rimetti Da Inviare" style="width: 150px">
                <template #body="{ data }">
                  <Button v-if="data.rinviato !== 1" label="Rimetti Da Inviare" @click="inviaFatturaAgyo(data.numero)" />
                </template>
              </Column>
            </DataTable>
          </div>
        </template>
      </Card>

      <!-- Sezione 3: Check Fatture -->
      <Card class="section-card">
        <template v-slot:content>
          <h4 class="titoloFatture">Check fatture</h4>
          <div v-if="loadingCheckFatture">
            <Loader />
          </div>
          <div v-else>
            <div class="search-controls">
            <input v-model="searchFattura" type="text" placeholder="Cerca per numero fattura" class="tab-search-input" />
             <button @click="getCheckFatture" class="search-button">
              <i class="pi pi-search"></i>
            </button>
          </div>
            <Accordion>
              <AccordionTab v-for="fattura in filteredCheckFatture" :key="fattura.numero" :header="'Fattura: ' + fattura.numero">
                <div class="datatable-container">
                  <DataTable :value="fattura.stati" class="w-full" scrollable="true">
                    <Column field="name" header="Stato" style="width: 20%"></Column>
                    <Column field="description" header="Descrizione" style="width: 40%">
                      <template #body="{ data }">
                        {{ data.description || ''}}
                      </template>
                    </Column>
                    <Column field="timestamp" header="Data" style="width: 40%"></Column>
                  </DataTable>
                </div>
              </AccordionTab>
            </Accordion>
          </div>
        </template>
      </Card>
    </div>
  </div>

  <!-- Dialog per mostrare le differenze -->
  <Dialog 
    v-model:visible="showDifferenceDialog" 
    :header="dialogHeader"
    :style="{width: '50vw'}"
    :modal="true"
  >
    <div class="difference-content">
      <template v-if="currentView === '2_3'">
        <div v-if="!statiCount?.differenza_stati_2_3?.numeri_fatture?.mancanti.length" class="no-differences">
          Nessuna fattura in attesa di conferma definitiva
        </div>
        <div v-else class="differences-list">
          <div class="difference-summary">
            <p>Fatture inviate ad Agyo in attesa di conferma definitiva: {{ statiCount.differenza_stati_2_3.count_differenze.mancanti }}</p>
          </div>
          <div class="difference-item">
            <ul>
              <li v-for="fattura in statiCount.differenza_stati_2_3.numeri_fatture.mancanti" :key="fattura">
                <a @click="openInvoice(fattura)" href="javascript:void(0)">{{ fattura }}</a>
              </li>
            </ul>
          </div>
        </div>
      </template>

      <template v-else-if="currentView === '4'">
        <div v-if="!statiCount?.fatture_stato_4?.numeri_fatture.length" class="no-differences">
          Nessuna fattura in stato di errore
        </div>
        <div v-else class="differences-list">
          <div class="difference-summary">
            <p>Fatture in stato di errore: {{ statiCount.fatture_stato_4.count }}</p>
          </div>
          <div class="difference-item">
            <ul>
              <li v-for="fattura in statiCount.fatture_stato_4.numeri_fatture" :key="fattura">
                <a @click="openInvoice(fattura)" href="javascript:void(0)">{{ fattura }}</a>
              </li>
            </ul>
          </div>
        </div>
      </template>

      <template v-else-if="currentView === '5'">
        <div v-if="!statiCount?.fatture_stato_5?.numeri_fatture.length" class="no-differences">
          Nessuna fattura vuota
        </div>
        <div v-else class="differences-list">
          <div class="difference-summary">
            <p>Fatture vuote: {{ statiCount.fatture_stato_5.count }}</p>
          </div>
          <div class="difference-item">
            <ul>
              <li v-for="fattura in statiCount.fatture_stato_5.numeri_fatture" :key="fattura">
                <a @click="openInvoice(fattura)" href="javascript:void(0)">{{ fattura }}</a>
              </li>
            </ul>
          </div>
        </div>
      </template>
    </div>
  </Dialog>
</template>

<script>
import { ref, computed, getCurrentInstance, onMounted } from "vue";
import { useStore } from "vuex";
import Service from "@/services/ask-caricamento-file/caricamento-file";
import Loader from "@/components/Loader.vue";
import { useToast } from "primevue/usetoast";
import Calendar from "primevue/calendar";
import TabView from "primevue/tabview";
import TabPanel from "primevue/tabpanel";
import Button from "primevue/button";
import moment from "moment";
import Accordion from 'primevue/accordion';
import AccordionTab from 'primevue/accordiontab';
import Dialog from 'primevue/dialog';

export default {
  components: {
    Loader,
    Calendar,
    TabView,
    TabPanel,
    Button,
    Accordion,
    AccordionTab,
    Dialog,
  },

  setup() {
    const store = useStore();
    const toast = useToast();
    const self = getCurrentInstance();
    self.$eventBus = self.appContext.config.globalProperties.$eventBus;
    const service = new Service(self.$eventBus);
    const fileToUpload = ref([]);
    const currentUser = ref(store.state.auth.user);
    const allowedType = ["zip", "x-zip-compressed"];
    const validationErrors = ref({});
    const submitted = ref(false);
    const loading = ref(false);
    const uploadedFiles = ref([]);
    const currentPageSending = ref(1);
    const currentPageSent = ref(1);
    const currentPageInviata = ref(1);
    const currentErrorPage = ref(1);
    const itemsPerPage = ref(30);
    const itemsPerPageError = ref(20);
    const logMessages = ref([]);
    const errorLogMessages = ref([]);
    const today = moment().format("YYYY-MM-DD");
    const dateRange = ref([new Date(today), new Date(today)]);
    const searchTerm = ref("");
    const searchTermErrore = ref("");
    const isSearchPerformed = ref(false);
    const isSearchPerformedErrore = ref(false);
    const fattureVuote = ref([]);
    const loadingFattureVuote = ref(false);
    const first = ref(0);
    const sortField = ref(null);
    const sortOrder = ref(null);
    const searchTermFattureVuote = ref("");
    const invoiceDetails = ref(null);
    const searchInvoiceNumber = ref("");
    const todayy = moment().startOf("day");
    const fifteenDaysAgo = moment().subtract(15, "days").startOf("day");
    const dateRangeError = ref([fifteenDaysAgo.toDate(), todayy.toDate()]);
    const loadingFattureDaRinviare = ref(false);
    const fattureDaRinviareCount = ref(0);
    const checkFattureData = ref([]);
    const loadingCheckFatture = ref(false);
    const searchFattura = ref('');
    const selectedMonth = ref(new Date());
    const statiCount = ref(null);
    const showDifferenceDialog = ref(false);
    const dialogHeader = ref('');
    const selectedDifferences = ref([]);
    const currentView = ref('2_3');
    const loadingStatiCount = ref(false);

    const performInvoiceSearch = async () => {
      if (!searchInvoiceNumber.value) {
        invoiceDetails.value = null;
        return;
      }

      loading.value = true;
      try {
        const res = await service.getInvoiceByNumber(searchInvoiceNumber.value);
        invoiceDetails.value = res;
      } catch (err) {
        console.error("Errore durante la ricerca della fattura:", err);
        toast.add({
          severity: "error",
          summary: "Errore",
          detail: `Errore durante la ricerca della fattura: ${err.message}`,
          life: 3000,
        });
      } finally {
        loading.value = false;
      }
    };

    const onSort = (event) => {
      sortField.value = event.sortField;
      sortOrder.value = event.sortOrder;

      if (event.sortField === "date" || event.sortField === "dataSDI") {
        fattureVuote.value.sort((a, b) => {
          const dateA = moment(a[event.sortField], "YYYY-MM-DD").toDate();
          const dateB = moment(b[event.sortField], "YYYY-MM-DD").toDate();

          if (sortOrder.value === 1) {
            return dateA - dateB;
          } else {
            return dateB - dateA;
          }
        });
      } else {
        fattureVuote.value.sort((a, b) => {
          const valA = a[event.sortField];
          const valB = b[event.sortField];

          if (sortOrder.value === 1) {
            return valA < valB ? -1 : valA > valB ? 1 : 0;
          } else {
            return valA > valB ? -1 : valA < valB ? 1 : 0;
          }
        });
      }
    };

    const isDateRangeValid = computed(() => {
      return (
        dateRange.value &&
        dateRange.value.length === 2 &&
        dateRange.value[0] !== null &&
        dateRange.value[1] !== null
      );
    });

    const isDateRangeErrorValid = computed(() => {
      return (
        dateRangeError.value &&
        dateRangeError.value.length === 2 &&
        dateRangeError.value[0] !== null &&
        dateRangeError.value[1] !== null
      );
    });

    const showDateRangeAlert = ref(false);

    const filteredLogMessages = computed(() => {
      if (!isDateRangeValid.value || !isSearchPerformed.value) {
        return [];
      }
      const start = moment(dateRange.value[0]).startOf("day");
      const end = moment(dateRange.value[1]).endOf("day");
      return logMessages.value.filter((log) => {
        const logTimestamp = moment(log.timestamp, "YYYY-MM-DD HH:mm:ss");
        const isWithinDateRange = logTimestamp.isBetween(
          start,
          end,
          null,
          "[]"
        );
        const matchesSearchTerm = log.numero.includes(searchTerm.value);
        return isWithinDateRange && matchesSearchTerm;
      });
    });

    const filteredErrorLogMessages = computed(() => {
      return errorLogMessages.value;
    });

    const categorizeLogs = (logs) => {
      return logs.reduce(
        (acc, log) => {
          if (log.stato === 4 && log.esitoSDI === "INVIATO") {
            acc[3].push(log);
          } else {
            acc[log.stato].push(log);
          }
          return acc;
        },
        { 1: [], 2: [], 3: [], 4: [] }
      );
    };

    const categorizedLogMessages = computed(() => {
      return categorizeLogs(filteredLogMessages.value);
    });

    const filteredLogMessagesByState = (state) => {
      return categorizedLogMessages.value[state];
    };

    const countByState = computed(() => {
      return {
        sending: filteredLogMessagesByState(1).length,
        sent: filteredLogMessagesByState(2).length,
        inviata: filteredLogMessagesByState(3).length,
        errore: filteredLogMessagesByState(4).length,
      };
    });

    const totalPagesByState = (state) => {
      return Math.ceil(
        filteredLogMessagesByState(state).length / itemsPerPage.value
      );
    };

    const totalErrorPages = computed(() => {
      return Math.ceil(
        filteredErrorLogMessages.value.length / itemsPerPageError.value
      );
    });

    const paginatedFilteredLogMessagesByState = (state) => {
      const currentPage =
        state === 1
          ? currentPageSending.value
          : state === 2
          ? currentPageSent.value
          : currentPageInviata.value;
      const startIndex = (currentPage - 1) * itemsPerPage.value;
      const endIndex = startIndex + itemsPerPage.value;
      return filteredLogMessagesByState(state).slice(startIndex, endIndex);
    };

    const paginatedFilteredErrorLogMessages = computed(() => {
      const startIndex = (currentErrorPage.value - 1) * itemsPerPageError.value;
      const endIndex = startIndex + itemsPerPageError.value;
      return filteredErrorLogMessages.value.slice(startIndex, endIndex);
    });

    const sortLogs = (logs) => {
      return logs.slice().sort((a, b) => {
        const dateA = moment(a.timeCreazione ?? a.timestamp);
        const dateB = moment(b.timeCreazione ?? b.timestamp);
        return dateB.diff(dateA);
      });
    };

    const filteredErrorLogMessagesSorted = computed(() => {
      return sortLogs(paginatedFilteredErrorLogMessages.value);
    });

    const countWithButton = computed(() => {
      return filteredErrorLogMessages.value.filter((log) => log.SDI !== 0)
        .length;
    });

    const nextPageSending = () => {
      if (currentPageSending.value < totalPagesByState(1)) {
        currentPageSending.value += 1;
      }
    };

    const prevPageSending = () => {
      if (currentPageSending.value > 1) {
        currentPageSending.value -= 1;
      }
    };

    const nextPageSent = () => {
      if (currentPageSent.value < totalPagesByState(2)) {
        currentPageSent.value += 1;
      }
    };

    const prevPageSent = () => {
      if (currentPageSent.value > 1) {
        currentPageSent.value -= 1;
      }
    };

    const nextPageInviata = () => {
      if (currentPageInviata.value < totalPagesByState(3)) {
        currentPageInviata.value += 1;
      }
    };

    const prevPageInviata = () => {
      if (currentPageInviata.value > 1) {
        currentPageInviata.value -= 1;
      }
    };

    const nextErrorPage = () => {
      if (currentErrorPage.value < totalErrorPages.value) {
        currentErrorPage.value += 1;
      }
    };

    const prevErrorPage = () => {
      if (currentErrorPage.value > 1) {
        currentErrorPage.value -= 1;
      }
    };

    const handleFileUpload = (evt) => {
      evt.preventDefault();
      submitted.value = false;
      fileToUpload.value = self.refs.file.files;
    };

    const performSearch = async () => {
      isSearchPerformed.value = true;
      isSearchPerformedErrore.value = false;
      showDateRangeAlert.value = !isDateRangeValid.value;
      if (!isDateRangeValid.value) {
        return;
      }
      loading.value = true;
      try {
        const startDate = moment(dateRange.value[0]).format("YYYY-MM-DD");
        const endDate = moment(dateRange.value[1]).format("YYYY-MM-DD");
        const res = await service.getLogsFattureAgyo(startDate, endDate);
        logMessages.value = Object.values(res).filter((log) => {
          const logTimestamp = moment(log.timestamp, "YYYY-MM-DD HH:mm:ss");
          const isWithinDateRange = logTimestamp.isBetween(
            moment(dateRange.value[0]).startOf("day"),
            moment(dateRange.value[1]).endOf("day"),
            null,
            "[]"
          );
          const matchesSearchTerm = log.numero.includes(searchTerm.value);
          return isWithinDateRange && matchesSearchTerm;
        });
      } catch (err) {
        console.error("Errore durante il caricamento dei log:", err);
        toast.add({
          severity: "error",
          summary: "Errore",
          detail: `Errore durante il caricamento dei log: ${err.message}`,
          life: 3000,
        });
      } finally {
        loading.value = false;
      }
    };

    const performSearchErrore = async () => {
      isSearchPerformedErrore.value = true;
      showDateRangeAlert.value = false;
      loading.value = true;

      try {
        const res = await service.getLogsFattureAgyoErrore();
        errorLogMessages.value = res;

        await inviaDatiErroreViaEmail();
      } catch (err) {
        console.error("Errore durante il caricamento dei log:", err);
        toast.add({
          severity: "error",
          summary: "Errore",
          detail: `Errore durante il caricamento dei log: ${err.message}`,
          life: 3000,
        });
      } finally {
        loading.value = false;
      }
    };

    const openInvoice = (numero) => {
      const baseUrl = process.env.VUE_APP_ADMIN_URL;
      const url = `${baseUrl}/ask/clienti/fatture/${numero}/dettagli`;
      window.open(url, "_blank");
    };

    const inviaFatturaAgyo = async (numero) => {
      try {
        const res = await service.InviaFatturaAgyoFromFile(numero);
        toast.add({
          severity: "success",
          summary: "Successo",
          detail: "Fattura inviata con successo",
          life: 3000,
        });
        const index = errorLogMessages.value.findIndex(
          (item) => item.numero === numero
        );

        if (index !== -1) {
          errorLogMessages.value[index].gestito = 1;
        }
        await performSearchErrore();

        return res;
      } catch (err) {
        toast.add({
          severity: "error",
          summary: "Errore",
          detail: `Errore durante l'invio della fattura: ${err.message}`,
          life: 3000,
        });
        self.$eventBus.emit("data-load-error", { message: err.message });
        throw err;
      }
    };

    const errorLogCount = computed(() => {
      return filteredErrorLogMessages.value.length;
    });

    const getFattureVuote = async () => {
      loadingFattureVuote.value = true;
      try {
        const res = await service.getFattureVuote();
        fattureVuote.value = res;
      } catch (err) {
        console.error(
          "Errore durante il caricamento delle fatture vuote:",
          err
        );
      } finally {
        loadingFattureVuote.value = false;
      }
    };

    const getFattureDaRinviareCount = async () => {
      loadingFattureDaRinviare.value = true;
      try {
        const res = await service.getFattureDaRinviareCount();
        fattureDaRinviareCount.value = res?.numeroFatture ?? 0;
      } catch (err) {
        console.error(
          "Errore nel recupero del conteggio delle fatture da rinviare:",
          err
        );
      } finally {
        loadingFattureDaRinviare.value = false;
      }
    };

    const rinviaTutteFattureErrore = async () => {
      loadingFattureDaRinviare.value = true;
      try {
        const res = await getFattureDaRinviareCount();
        fattureDaRinviareCount.value = res.numeroFatture;
      } catch (err) {
        console.error("Errore durante il rinvio delle fatture:", err);
      } finally {
        loadingFattureDaRinviare.value = false;
      }
    };

    const paginatedFattureVuote = computed(() => {
      const start = first.value;
      const end = start + 10;
      return fattureVuote.value.slice(start, end);
    });

    const onPage = (event) => {
      first.value = event.first;
    };

    const filteredFattureVuote = computed(() => {
      if (!searchTermFattureVuote.value) {
        return fattureVuote.value;
      }
      return fattureVuote.value.filter((fattura) =>
        fattura.numero.includes(searchTermFattureVuote.value)
      );
    });

    const datiDaInviare = computed(() => {
      return filteredErrorLogMessagesSorted.value.map((log) => ({
        numeroFattura: log.numero,
        hubId: log.hubId,
        timestamp: moment(log.timestamp).format("YYYY-MM-DD HH:mm:ss"),
        message: log.message,
        descrizioneAgyo: log.descrizioneAgyo,
        SDI: log.SDI,
      }));
    });

    const inviaDatiErroreViaEmail = async () => {
      if (datiDaInviare.value.length > 0) {
        try {
          const res = await service.inviaFattureErroreViaEmail({
            fattureErrore: datiDaInviare.value,
          });
          console.log("Email inviata con successo:", res);
        } catch (err) {
          console.error("Errore durante l'invio dell'email:", err);
        }
      } else {
        console.log("Nessuna fattura da inviare via email.");
      }
    };

    const getCheckFatture = async () => {
      loadingCheckFatture.value = true;
      try {
        const res = await service.getCheckFatture();
        checkFattureData.value = res;
        if (res.length === 0) {
          toast.add({
            severity: "info",
            summary: "Info",
            detail: "Nessuna fattura trovata tra le 12 alle 24 ore",
            life: 3000,
          });
        }
      } catch (err) {
        console.error("Errore durante il recupero dei check fatture:", err);
        toast.add({
          severity: "error",
          summary: "Errore",
          detail: `Errore durante il recupero dei check fatture: ${err.message}`,
          life: 3000,
        });
      } finally {
        loadingCheckFatture.value = false;
      }
    };

    const filteredCheckFatture = computed(() => {
      if (!searchFattura.value) {
        return checkFattureData.value;
      }
      return checkFattureData.value.filter(fattura => 
        fattura.numero.toLowerCase().includes(searchFattura.value.toLowerCase())
      );
    });

    const getCountStati = async () => {
      loadingStatiCount.value = true;
      try {
        const formattedDate = moment(selectedMonth.value).format('YYYY-MM');
        const response = await service.getCountFattureAgyo(formattedDate);
        statiCount.value = response;
      } catch (err) {
        console.error("Errore nel recupero del conteggio stati:", err);
        toast.add({
          severity: "error",
          summary: "Errore",
          detail: "Errore nel recupero del conteggio degli stati",
          life: 3000,
        });
      } finally {
        loadingStatiCount.value = false;
      }
    };

    const showDifferences = (tipo) => {
      if (!statiCount.value) return;
      
      currentView.value = tipo;
      
      switch(tipo) {
        case '2_3':
          dialogHeader.value = 'Fatture in attesa di conferma definitiva';
          break;
        case '4':
          dialogHeader.value = 'Fatture in stato di errore';
          break;
        case '5':
          dialogHeader.value = 'Fatture vuote';
          break;
      }
      
      showDifferenceDialog.value = true;
    };

    return {
      moment,
      store,
      validationErrors,
      submitted,
      service,
      fileToUpload,
      handleFileUpload,
      allowedType,
      loading,
      logMessages,
      errorLogMessages,
      filteredLogMessages,
      filteredErrorLogMessages,
      filteredLogMessagesByState,
      countByState,
      paginatedFilteredLogMessagesByState,
      paginatedFilteredErrorLogMessages,
      filteredErrorLogMessagesSorted,
      countWithButton,
      totalPagesByState,
      totalErrorPages,
      currentPageSending,
      currentPageSent,
      currentPageInviata,
      currentErrorPage,
      nextPageSending,
      prevPageSending,
      nextPageSent,
      prevPageSent,
      nextPageInviata,
      prevPageInviata,
      nextErrorPage,
      prevErrorPage,
      dateRange,
      dateRangeError,
      searchTerm,
      searchTermErrore,
      isDateRangeValid,
      isDateRangeErrorValid,
      performSearch,
      performSearchErrore,
      isSearchPerformed,
      isSearchPerformedErrore,
      openInvoice,
      inviaFatturaAgyo,
      errorLogCount,
      showDateRangeAlert,
      fattureVuote,
      loadingFattureVuote,
      first,
      onPage,
      onSort,
      paginatedFattureVuote,
      searchTermFattureVuote,
      filteredFattureVuote,
      searchInvoiceNumber,
      invoiceDetails,
      performInvoiceSearch,
      getFattureVuote,
      loadingFattureDaRinviare,
      fattureDaRinviareCount,
      getFattureDaRinviareCount,
      rinviaTutteFattureErrore,
      checkFattureData,
      loadingCheckFatture,
      getCheckFatture,
      searchFattura,
      filteredCheckFatture,
      selectedMonth,
      statiCount,
      getCountStati,
      showDifferenceDialog,
      dialogHeader,
      selectedDifferences,
      showDifferences,
      currentView,
      loadingStatiCount,
    };
  },
};
</script>

<style>
/* Variables */
:root {
  --primary-color: #1f5d38;
  --secondary-color: #164628;
  --accent-color: #63796c;
  --background-color: #f8fafc;
  --text-primary: #1a1a1a;
  --text-secondary: #666666;
  --border-color: #e5e7eb;
  --success-color: #4CAF50;
  --error-color: #dc2626;
  --card-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

/* Struttura originale - Layout base */
.center-content {
  display: flex;
  flex-direction: column;
  width: 100%;
  margin: 0 auto;
  padding: 1rem;
}
.horizontal-sections-wrapper {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1rem;
  width: 100%;
  margin-top: 1rem;
}

.section-card {
  flex: 1;
  background: white;
  border-radius: 8px;
  box-shadow: var(--card-shadow);
  min-width: 0; /* Previene overflow del contenuto */
}
.history-card {
  width: 100%;
  margin-bottom: 1rem;
  box-shadow: var(--card-shadow);
  border-radius: 8px;
  background: white;
}

.error-card {
  width: 100%;
  margin: 1rem 0;
  box-shadow: var(--card-shadow);
  border-radius: 8px;
  background: white;
}

/* Headers */
.titoloH4, .titoloFatture {
  text-align: center;
  margin: 10px 0 20px 0;
  font-size: 1.25rem;
  color: var(--text-primary);
  font-weight: 600;
  padding-bottom: 10px;
  border-bottom: 2px solid var(--border-color);
}

/* Search and Filters */
.filters {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-bottom: 1rem;
}

.date-picker-container {
  display: flex;
  flex-direction: column;
}

.date-picker-container label {
  font-weight: 500;
  margin-bottom: 0.5rem;
}

.date-range-box-wrapper {
  display: flex;
  align-items: center;
}

.date-range-box {
  flex: 1;
  border: 1px solid var(--border-color);
  border-radius: 4px;
  background: white;
}
.search-controls {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1rem;
  width: 100%;
}
.search-controls .tab-search-input {
  flex: 1;
  max-width: none;
}

.search-controls .search-button {
  margin: 0;
  min-width: 40px;
  height: 40px;
}
/* Search Input e Button */
.tab-search-input {
  padding: 0.75rem;
  border: 1px solid var(--border-color);
  border-radius: 4px;
  width: 100%;
  max-width: 400px;
}

.search-button {
  margin-left: 1rem;
  padding: 0.75rem;
  border: none;
  border-radius: 4px;
  background-color: var(--primary-color);
  color: white;
  cursor: pointer;
  height: 40px;
  width: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.search-button i {
  font-size: 1rem;
}

/* DataTable e Table styling */
.table-container {
  margin-top: 1rem;
  width: 100%;
  overflow-x: auto;
}

:deep(.p-datatable) {
  width: 100%;
}

:deep(.p-datatable .p-datatable-thead > tr > th) {
  background: var(--primary-color);
  color: white;
  padding: 1rem;
  border: none;
  font-weight: 500;
}

:deep(.p-datatable .p-datatable-tbody > tr > td) {
  padding: 1rem;
  border-bottom: 1px solid var(--border-color);
}

/* Pagination */
.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1rem;
  margin: 1rem 0;
}

.pagination button {
  padding: 0.5rem 1rem;
  border: 1px solid var(--border-color);
  border-radius: 4px;
  background: white;
  cursor: pointer;
  color: var(--text-primary);
}

.pagination button:disabled {
  background-color: var(--background-color);
  cursor: not-allowed;
  color: var(--text-secondary);
}

/* Alert styles */
.alert {
  padding: 1rem;
  border-radius: 4px;
  margin-bottom: 1rem;
}

.alert-danger {
  background-color: #fee2e2;
  border: 1px solid #fecaca;
  color: var(--error-color);
}

/* TabView customization */
:deep(.p-tabview) {
  width: 100%;
}

:deep(.p-tabview-panels) {
  padding: 1.5rem 0;
}

:deep(.p-tabview-nav) {
  border-bottom: 2px solid var(--border-color);
}

:deep(.p-tabview-nav-link) {
  padding: 1rem;
  color: var(--text-secondary);
}

:deep(.p-tabview-selected) {
  border-bottom: 2px solid var(--primary-color);
  color: var(--primary-color);
}

/* Tab count badge */
.tab-count {
  background-color: var(--accent-color);
  color: white;
  padding: 0.2rem 0.6rem;
  border-radius: 12px;
  font-size: 0.85rem;
  margin-left: 0.5rem;
}

/* Button States */
.rinvia-button {
  display: inline-flex;
  align-items: center;
  background-color: var(--primary-color);
  color: white;
  border: none;
  padding: 0.75rem 1.5rem;
  border-radius: 4px;
  cursor: pointer;
  font-weight: 500;
  transition: background-color 0.2s;
}

.rinvia-button:hover {
  background-color: var(--secondary-color);
}
.table-container {
  overflow-x: auto;
  max-width: 100%;
}

:deep(.p-datatable) {
  width: 100%;
  min-width: 0; 
}
/* Responsive adjustments */
@media (max-width: 768px) {
  .date-range-box-wrapper {
    flex-direction: column;
  }
  
  .search-button {
    margin: 0.5rem 0;
    width: 100%;
  }
  
  .tab-search-input {
    max-width: 100%;
  }
  .horizontal-sections-wrapper {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 768px) {
  .horizontal-sections-wrapper {
    grid-template-columns: 1fr;
  }
}

.count-stati-card {
  margin-top: 1rem;
}

.stati-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 1rem;
  margin-top: 1rem;
}

.stato-box {
  background: #f8f9fa;
  border-radius: 8px;
  padding: 1rem;
  text-align: center;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  cursor: pointer;
  transition: transform 0.2s, box-shadow 0.2s;
}

.stato-box:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 6px rgba(0,0,0,0.1);
}

.stato-box h5 {
  margin: 0 0 0.5rem 0;
  color: var(--text-primary);
  font-weight: 500;
}

.stato-box .count {
  font-size: 1.5rem;
  font-weight: 600;
  color: var(--primary-color);
}

.difference-content {
  padding: 1rem;
}

.no-differences {
  text-align: center;
  color: var(--text-secondary);
  padding: 1rem;
}

.differences-list {
  margin-bottom: 1rem;
}

.difference-item {
  margin-bottom: 1rem;
  padding: 1rem;
  background: #f8f9fa;
  border-radius: 4px;
}

.difference-item h6 {
  margin: 0 0 0.5rem 0;
  color: var(--text-primary);
}

.difference-item ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.difference-item li {
  margin: 0.25rem 0;
}

.difference-item a {
  color: var(--primary-color);
  text-decoration: none;
}

.difference-item a:hover {
  text-decoration: underline;
}

.search-button-primary {
  background-color: var(--primary-color);
  color: white;
  border: none;
  padding: 0.75rem 1.5rem;
  border-radius: 4px;
  cursor: pointer;
  font-weight: 500;
  transition: background-color 0.2s;
  height: auto;
  width: auto;
  margin: 0;
}

.search-button-primary:hover {
  background-color: var(--secondary-color);
}

.search-controls {
  display: flex;
  gap: 1rem;
  align-items: center;
}

.loader-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 200px;
}
</style>